const DISABLED_CLIENTS = [
  'virgin',
  'jcrew',
  'cathay',
  'onepaywalmart',
  'suncountry'
]

const isAccountLinkDisabledForAClient = (clientId: string) => {
  return DISABLED_CLIENTS.includes(clientId)
}

export { DISABLED_CLIENTS }
export default isAccountLinkDisabledForAClient
